import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

// css load
import "assets/css/nucleo-svg.css";
import "assets/css/nucleo-icons.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-design-system.scss?v1.0.0";
import "assets/scss/app.sass";

import OldSiteRedirect from 'views/specials/OldSiteRedirect';
import PublicRelations from './views/old-website/PublicRelations';

// PLAYGROUND GROUP
import PlaygroundPage from 'views/page/playground/PlaygroundPage';

import Goto from './t4/pages/Goto';

import NewsViewGen4 from './views/page/news/NewsViewGen4';

import ProspectivePage from "./t4/pages/person/prospective/ProspectivePage";
import StudentPage from "./t4/pages/person/student/StudentPage";
import ParentPage from "./t4/pages/person/parent/ParentPage";
import AlumniPage from "./t4/pages/person/alumni/AlumniPage";
import PersonPage from "./t4/pages/person/person/PersonPage";
import StaffPage from "./t4/pages/person/staff/StaffPage";

import EventReadPage from "./views/page/event/Read";

// SITE GROUP
const LandingPage = React.lazy(() => import('views/LandingPage.js'));

const SearchLanding = React.lazy(() => import('views/page/SearchLanding'));
const SearchDetail = React.lazy(() => import('views/page/SearchDetail'));

const News = React.lazy(() => import('views/page/news/News'));
const NewsView = React.lazy(() => import('./views/page/news/NewsView'));

const PrivacyPolicy = React.lazy(() => import('./views/page/legal/PrivacyPolicy'));
const CacheClear = React.lazy(() => import('./views/page/legal/CacheClear'));



const Credits = React.lazy(() => import('./t4/pages/others/Credits'));
const AllService = React.lazy(() => import('./t4/pages/AllService'));
const NewsPortal = React.lazy(() => import('./t4/pages/NewsPortal'));
const IframePageComponent = React.lazy(() => import('./playground-components/pages/IframePageComponent'));
const RedirectPageComponent = React.lazy(() => import('./playground-components/pages/RedirectPageComponent'));
const ExternalLinkPage = React.lazy(() => import('./t4/pages/ExternalLinkPage'));
const Page = React.lazy(() => import('./project-components/pages/Page'));
const ApiPage = React.lazy(() => import('project-components/pages/ApiPage'));
const ApiPageBySlug = React.lazy(() => import('project-components/pages/ApiPageBySlug'));
const PageView = React.lazy(() => import('views/page/page/PageView'));
const Error404 = React.lazy(() => import('views/page/errors/Error404'));
const BackendPageDraft = React.lazy(() => import('views/page/playground/BackendPageDraft'));
const AllServicePage = React.lazy(() => import('./views/page/services/AllServicePage'));

ReactDOM.render(
  <BrowserRouter basename="/">
    <Suspense fallback={<div></div>}>
      <Switch>

        {/************************************************
          * SWITCHER, REDIRECT | การสลับหรือส่งต่อไปหน้าอื่น
          ************************************************/}
        <Route exact path="/">      <Redirect to="/index" />    </Route>
        <Route exact path="/index"> <Redirect to="/th/index" /> </Route>

        {/****************************
         * หน้าเว็บไซต์สำหรับการทดสอบ
         ****************************/}
        <Route exact path="/playground" component={PlaygroundPage} />
        <Route exact path="/draft" component={BackendPageDraft} />
        <Route exact path="/tesseract" component={Page} />
        <Route exact path="/old-republic" component={NewsPortal} />

        <Route exact path="/testa" component={AllServicePage} />
        {/* <Route exact path="/test/jstree" component={} */}

        <Route exact path="/credits"  component={Credits} />
        <Route exact path="/clear"    component={CacheClear} />

        <Route exact path="/goto/:slug" component={Goto} />

        {/*******************
          *
          *******************/}

        {/* หน้าหลัก */}
        <Route exact path="/:lang/index" component={LandingPage} />

        {/* การค้นหา */}
        <Route exact path="/:lang/search" component={SearchLanding} />
        <Route exact path="/:lang/search/detail" component={SearchDetail} />

        {/* แสดงผลข่าว */}
        <Route exact path="/:lang/newspaper/:newsCategoryId"  component={News}         />

        {/** URL ของเว็บเดิม */}
        <Route exact path="/:lang/news/public_relations" component={PublicRelations} />
        {/** ถ้ามาจากลิงค์นี้ให้ใช้ ID อ้างอิงของ Core */}
        <Route exact path="/:lang/news/:newsId" component={NewsViewGen4} />
        {/** ถ้ามาจากลิงค์นี้ให้ใช้ ID อ้างอิงของ ระบบใหม่ */}
        <Route exact path="/:lang/news-view/:newsId" component={NewsView} />

        <Route exact path="/:lang/event/:eventId" component={EventReadPage} />

        <Route exact path="/:lang/privacy-policy" component={PrivacyPolicy}  />
        <Route exact path="/:lang/cache-clear"    component={CacheClear}  />

        <Route exact path="/:lang/prospective"  component={ProspectivePage} />
        <Route exact path="/:lang/student"      component={StudentPage} />
        <Route exact path="/:lang/parent"       component={ParentPage} />
        <Route exact path="/:lang/alumni"       component={AlumniPage} />
        <Route exact path="/:lang/person"       component={PersonPage} />
        <Route exact path="/:lang/staff"        component={StaffPage} />

        <Route exact path="/:lang/services" component={AllServicePage} />

        <Route exact path="/:lang/news-portal" component={NewsPortal} />
        <Route exact path="/:lang/news-portal/:newsCategoryId" component={NewsPortal} />

        <Route exact path="/:lang/ext-link" component={ExternalLinkPage} />

        {/* หน้า */}
        <Route exact path="/:lang/:slug"          component={PageView}         />

        <Route exact path='/:lang/:one/:two/:three?' component={OldSiteRedirect}/>

        <Route component={Error404} />

      </Switch>
    </Suspense>
  </BrowserRouter>,
  document.getElementById("root")
);
